/**
 * Tema claro / oscuro del sitio.
 *
 * <p>Antes lo aplicaba el panel de filtros al montarse, asi que en las paginas sin listado el
 * tema dependia de haber pasado antes por el. Ahora lo aplica App al arrancar y el switch vive
 * en el pie.
 */
const CLAVE = "theme";

/** El guardado, o oscuro si nunca se eligio (fue siempre el default). */
export const temaGuardado = () => {
    try {
        return localStorage.getItem(CLAVE) || "dark";
    } catch (e) {
        return "dark";
    }
};

export const aplicarTema = (tema) => {
    document.body.classList.add("theme-switch");
    try {
        localStorage.setItem(CLAVE, tema);
    } catch (e) {
        // sin storage el tema vale para esta visita
    }
    document.body.setAttribute("data-theme", tema);

    document.body.addEventListener(
        "transitionend",
        () => document.body.classList.remove("theme-switch"),
        {once: true}
    );
};
